import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    price: null,
    error: null,
});

const reducer = (state = initState(), action) => {
    switch (action.type) {
        case DispatchConstants.GET_PAID_INCLUSION_PRICE_SUCCESS:
            return { ...state, price: action.payload.price };
        case DispatchConstants.GET_PAID_INCLUSION_PRICE_FAIL:
            return { ...state, error: action.payload };
        default:
            return state;
    }
};

export default reducer;
